import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Navigation/BackToTop/backToTop.container"
    ).then((module) => ({
        default: module.BackToTop
    }))
);
